export const checkErrorMessage = (err) => {
    let errorDetails = {
      message: false,
      params: false,
      titles: false,
      status: 406,
    };
    
    if (
      err &&
      err["response"] &&
      err["response"]["data"] &&
      err["response"]["data"]["data"]
    ) {
      if (err["response"]["data"]["data"]["titles"])
        errorDetails.titles =
          err["response"]["data"]["data"]["titles"].join(" - ");
      if (err["response"]["data"]["data"]["params"])
        errorDetails.params = err["response"]["data"]["data"]["params"];
      errorDetails.message = errorDetails.titles || "خطا در درخواست";
    } else if (
      err &&
      err["response"] &&
      err["response"]["data"] &&
      err["response"]["data"]["message"]
    ) {
      errorDetails.message = err["response"]["data"]["message"];
    } else {
      errorDetails.message = "لطفا بعدا تلاش کنید";
    }
    
    if (err && err["response"] && err["response"]["status"]) {
      errorDetails.status = err["response"]["status"];
    }
    
    return errorDetails;
  };
  
  export const checkResponseData = (response) => {
    let responseDetails = {
      success: false,
      message: false,
      data: false,
      moreInfo: {},
      token: null,
      refreshToken: null,
    };
    
    if (response && response["data"] && response["data"]["success"]) {
      if (response["data"]["message"])
        responseDetails.message = response["data"]["message"];
      if (response["data"]["data"])
        responseDetails.data = response["data"]["data"];
      if (response["data"]["token"])
        responseDetails.token = response["data"]["token"];
      if (response["data"]["refreshToken"])
        responseDetails.refreshToken = response["data"]["refreshToken"];
      if (response["data"]["moreInfo"])
        responseDetails.moreInfo = response["data"]["moreInfo"];
      responseDetails.success = true;
    }
    
    return responseDetails;
  };